import React from 'react';
import '../styles/EditAddressModal.css';
import { SearchInput, PredictiveSearch } from '../components';

function EditAddressModal({
    currentAddress,
    addressSearch,
    onAddressSearchChange,
    addressSearchResults,
    addressSearching,
    addressSelected,
    onSelectAddress,
    onClearAddress,
    selectedAddressLabel,
    error
}) {
    const currentAddressDisplay = currentAddress
        ? (currentAddress.label || [currentAddress.streetAddress, currentAddress.city, currentAddress.state, currentAddress.zipcode].filter(Boolean).join(', '))
        : 'Unknown address';

    return (
        <div className="edit-address-modal-body">
            <div className="edit-address-section">
                <span className="body-bold colour-primary edit-address-section-label">
                    Current address
                </span>
                <span className="body-regular colour-secondary">
                    {currentAddressDisplay}
                </span>
            </div>

            <div className="light-grey-divider"></div>

            <div className="edit-address-section">
                <span className="body-bold colour-primary edit-address-section-label">
                    Correct address
                </span>
                {
                    addressSelected === true ?
                    <div className="edit-address-selected">
                        <span className="body-regular colour-primary">
                            {selectedAddressLabel}
                        </span>
                        <span
                            className="body-bold colour-link cursor-pointer"
                            onClick={onClearAddress}
                        >
                            Change
                        </span>
                    </div>
                    :
                    <div className="edit-address-search-container relative-container">
                        <SearchInput
                            value={addressSearch}
                            onChange={onAddressSearchChange}
                            placeholder="Search for any address in the U.S."
                            type="text"
                            clearInput={onClearAddress}
                            magnifyingGlassFunc={null}
                            searchLoading={addressSearching}
                            disabled={false}
                        />
                        {
                            addressSearch !== "" && (addressSearchResults.length > 0 || addressSearching === true) &&
                            <PredictiveSearch
                                loading={addressSearching}
                                results={addressSearchResults}
                                selectItem={onSelectAddress}
                                nested={false}
                            />
                        }
                    </div>
                }
            </div>

            <span className="body-regular colour-secondary">
                After submitting, enrichment will re-run automatically. This may take a few minutes.
            </span>

            {
                error !== null && error !== undefined &&
                <span className="body-regular colour-error edit-address-error">
                    {error}
                </span>
            }
        </div>
    );
}

export default EditAddressModal;
